const projectsList = [
    {
        "name": "Cornucopia, Land of Excess",
        "picture": "cornucopia",
        "tech-stack": ["React Hooks", "Redux", "React Router", "CSS", "Testing: Jest/Enzyme", "Piskel"],
        "description": "Web-based game that allows for users to plant and harvest crops, fight monsters, and play several mini-games. Click on the apple to access Cornucopia.",
        "landing": "https://cornucopia.netlify.com/",
        "github": "https://github.com/azinoVo/neopet_clone"
    },
    {
        "name": "Roamly",
        "picture": "RoamlyResized",
        "tech-stack": ["React Hooks, CSS Modules", "NodeJS, Express, PostgreSQL, Knex, GraphQL", "Travis CI", "FullStory Analytics, Google Analytics, Heap Analytics", "OAuth with Google Sign-In", "Google API", "Jest, Enzyme, Cypress"],
        "description": "Travel application that allows users to search, view, favorite, and un-favorite attractions for a particular destination. Favorite attractions are added to a user profile associated with Google Login.",
        "landing": "https://roamly.app/",
        "github": "https://github.com/labs14-travel-website/frontend"
    },
    {
        "name": "Gigapet",
        "picture": "GigapetResized",
        "tech-stack": ["React Class", "Redux", "React Router", "Styled Components", "JSON Web Tokens"],
        "description": "Healthy eating application for parents who want to track what their children are consuming as well as calorie count. Parents may add children, add and edit food/drink items for each child, and search for items depending on criteria such as time or type. Anyone that uses the application will be able to play the secret Dragon game which promotes healthy eating.",
        "landing": "https://gigapetapp.netlify.com/signUp",
        "github": "https://github.com/gigapet-eating-log/gigapet-FE"
    },
    {
        "name": "FoodieFun",
        "picture": "FoodieFunResized",
        "tech-stack": ["React Class", "Redux", "CSS", "REST API", "NodeJS, Express, Knex, SQLite3", "JSON Web Tokens"],
        "description": "Restaurant review application that uses a REST-ful backend to manipulate data via CRUD operations. Solely worked on the Backend and helped debug the Frontend.",
        "landing": "https://foodiefun.netlify.com/",
        "github": "https://github.com/foodie-fun/FFBE"
    },
    {
        "name": "D&D Encounter Generator",
        "picture": "DNDResized",
        "tech-stack": ["React Class", "Redux", "CSS", "Styled Components"],
        "description": "Quality of life application that allows dungeon masters of Dungeons and Dragons to generate encounter creatures as well as keep track of turn order. Built by six developers over three days as part of a Hackathon event.",
        "landing": "https://5e-encounters.netlify.com/",
        "github": "https://github.com/DuckEverlasting/Random-Character-Generator"

    }
]

export default projectsList;